import React, { useState } from "react";
import styled from "styled-components";

import { lightThemeColors } from "../../assets/style/colors";
import { ReactComponent as DownIcon } from "../../assets/icons/downIcon.svg";
import { AnimatePresence, motion } from "framer-motion";
import AnimatedTextButton from "../generic/AnimatedTextButton";

const InfoDropdown = ({ title, dropdownTitle, learnMoreClick, infoText }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Container>
      <MenuDropdown onClick={() => setIsOpen(!isOpen)} isOpen={isOpen}>
        <DropdownTitle isOpen={isOpen}>
          {dropdownTitle}
        </DropdownTitle>
        <DownIcon style={!isOpen ? { color: lightThemeColors.darkColor } : { rotate: "180deg", color: lightThemeColors.lightColor }} />
      </MenuDropdown>
      <AnimatePresence>
        {isOpen &&
          <motion.div
            initial={{ height: 0 }}
            animate={{ height: "auto", }}
            exit={{ height: 0 }}
            transition={{ duration: 0.4 }}
          >
            <DropdownContent >
              {title && <Title>{title}</Title>}
              <Infotext>{infoText}</Infotext>
              {learnMoreClick && <AnimatedTextButton
                style={{
                  borderBottom: `1px solid ${lightThemeColors.darkColor}`,
                  fontWeight: "600",
                }}
                onClick={learnMoreClick}
                text={"Learn More"}
              />}

            </DropdownContent>
          </motion.div>
        }
      </AnimatePresence>
    </Container>
  )
}

export default InfoDropdown;

const Container = styled(motion.div)`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  max-width:900px;
`;
const MenuDropdown = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  justify-content: space-between;
  background: ${(props) =>
    props.isOpen
      ? lightThemeColors.dropDownBackgroundOpen
      : lightThemeColors.dropDownBackgroundClosed};
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  svg {
    height: 8px;
    width: 16px;
  }
`;
const DropdownContent = styled(motion.div)`
display:flex;
flex-direction:column;
gap:30px;
overflow:hidden;
padding:20px;
`
const DropdownTitle = styled.p`
  color: ${(props) =>
    props.isOpen ? lightThemeColors.lightColor : lightThemeColors.darkColor};
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  @media (max-width: 550px) {
    font-size: 18px;
    line-height: 22px;
    white-space:normal;
  }
`;
const Infotext = styled.p`
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
  color: ${lightThemeColors.darkColor};
`;

const Title = styled.p`
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  color: ${lightThemeColors.darkColor};
`;
